<template>
<div>
  <modal v-model="show"
         :title="`Inscription SPIADI ${year}`"
         :footer="false"
         id="establishment-add-modal"
         size="lg">
    <div class="row" v-if="show">
      <div class="col-xs-12">
        <div v-if="list.length > 0" class="form-group">
          <div>
            <h3>Sélectionner un établissement précédemment inscrit</h3>
          </div>
          <div class="row">
            <div class="col-xs-12"
                 v-for="l in list" :key="`${l.id}-finess`">
              <a role="button" size="sm" class="establishment-button"
                 @click="finess = l.establishment.finess">
                {{ l.establishment.finess }} - {{ l.establishment.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12" v-if="list.length > 0">
        <h3>OU</h3>
      </div>
      <div class="col-xs-12">
        <sui-finess @error="setFinessError"
                    @result="setFinessResult"
                    :disabled="waiting"
                    :initialFiness="finess"
        />

      </div>
    </div>
    <div class="row" v-if="show">
      <div class="col-xs-12">
        <div id="finess-message">
          <sui-error-panel :error="finessError" v-if="finessError.error">
          </sui-error-panel>
          <form v-else-if="result != null">
            <div class="form-group"
                 v-for="(v, k) in { name: 'RAISON SOCIALE', address: 'ADRESSE' }"
                 :key="k">
              <label for="name" class="control-label">{{v}}</label>
              <input id="name"
                     class="form-control"
                     v-model="result[k]"
                     disabled="true">
            </div>
            <alert type="warning" class="text-justify">
              <h4>
                <strong>
                  Avant de terminer votre inscription et d'ouvrir l'espace
                  SPIADI pour votre établissement, merci de bien prendre
                  note des informations suivantes :
                </strong>
              </h4>
              <ul>
                <li>
                  Vous deviendrez <strong>le ou la responsable</strong> du
                  programme SPIADI {{year}} pour cet établissement
                </li>
                <li>
                  <strong> Le choix des modules de surveillance </strong>
                  (Bact ADI, Exp ADI, ...)
                  <strong> et d'observation des pratiques </strong>
                  (OBSERVA4 et RÉA expl AUR)
                  <strong>
                    s'effectue directement depuis cet espace SPIADI
                  </strong>
                </li>
                <li>
                  Vous pourrez <strong>modifier votre inscription</strong> à ces
                  modules <strong>autant de fois que nécessaire</strong><br />
                  <small>
                    (Tant qu'aucune fiche n'aura été saisie dans les modules à
                    modifier)
                  </small>
                </li>
                <li>
                  Afin que votre <strong>participation</strong> à la
                  surveillance soit <strong>validée</strong>, il faut que nous
                  ayons reçu <strong>vos fiches</strong> et <strong>
                  dénominateurs</strong> correspondant à la période surveillée
                  ainsi que <strong>votre charte d'engagement signée ou mise
                  à jour, et ce avant le 31&nbsp;août&nbsp;{{year}}</strong>
                  <small>
                    (Ces étapes de validations seront progressivement
                    disponibles dans votre espace SPIADI)
                  </small>
                </li>
                <li>
                  La <strong>période de surveillance attendue</strong> est de
                  <strong>
                    3 mois au choix entre le 1er&nbsp;janvier et le 15&nbsp;juillet
                    &nbsp;{{year}}
                  </strong>
                </li>
              </ul>
              <sui-error-panel :error="error">
              </sui-error-panel>

              <div v-if="waiting">
                <alert type="info">
                  <progress-bar
                    v-model="progress"
                    striped
                    label
                    :label-text="`Inscription de l'établissement à la surveillance SPIADI ${year}`"
                    active />
                </alert>
              </div>
              <div v-else>
                <p class="text-center">
                  <btn @click="save"
                       :disabled="!show"
                       type="success"
                       size="lg">
                    Ouvrir l'espace SPIADI pour mon établissement
                  </btn>
                </p>
              </div>
            </alert>
          </form>
        </div>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import Error from '@/sui/tools/error'

import suiErrorPanel from '@/sui/components/errorpanel'
import suiFiness from '@/sui/components/establishment/finess'

import cleave from 'vue-cleave-component'

export default {
  name: 'add-establishment',
  props: {
    value: {
      type: Boolean,
      required: true
    },

    list: {
      type: Array,
      default: () => []
    },

    year: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      show: this.value,
      finess: '',
      progress: 100,
      finessError: new Error(),
      error: new Error(),
      result: null,
      waiting: false
    }
  },

  methods: {
    setFinessResult: function (fr) {
      this.result = fr
    },

    setFinessError: function (fe) {
      this.finessError = fe
      this.result = null
    },

    setBasicError: function () {
      this.error.set(
        'Erreur interne !',
        `Une erreur inattendue s'est produite lors de l'inscription de
        votre établissement.`,
        `Vérifiez votre connexion internet avant de réessayer.`
      )
    },

    save: function () {
      this.waiting = true
      this.error.reset()
      const vm = this
      this.$store.dispatch(
        'surveillances/subscribe',
        {
          etb: this.result.target,
          year: parseInt(this.year)
        }
      ).then(r => {
        if (r.data.err == null) {
          vm.$alert({
            html: true,
            content: `<p class="text-justify"><strong>L'espace SPIADI ${this.year} pour l'établissement
«${this.result.name}» (finess n°${this.finess}) a bien été ouvert !
</strong></p><p class="text-justify">Vous pouvez désormais cliquer sur le bouton associé
            à cet établissement pour choisir les modules de surveillance.</p>`,
            title: ``
          })
          this.show = false
        } else {
          this.waiting = false
          if (r.data.err === '[Duplicate]') {
            this.error.set(
              'Établissement déjà inscrit !',
              `Un espace SPIADI ${this.year} a déjà été ouvert pour cet établissement`
            )
          } else {
            this.setBasicError()
          }
        }
      }).catch(() => {
        this.waiting = false
        this.setBasicError()
      })
    }
  },

  watch: {
    value: function () {
      this.show = this.value
      if (this.show) {
        this.valid = false
        this.error.reset()
        this.finessError.reset()
        this.result = null
        this.waiting = false
        this.finess = ''
      }
    },

    show: function (v) {
      this.$emit('input', v)
    }
  },

  components: {
    'sui-finess': suiFiness,
    'sui-error-panel': suiErrorPanel,
    'cleave': cleave
  }
}
</script>
<style lang="less" scoped>
#establishment-add-modal {
  .alert li {
    font-size: 110%;
    list-style-type: decimal;
    margin: 2rem;
  }

  .establishment-button {
    margin: 0.2rem;
    margin-left: auto;
    margin-right: auto;
    font-weight: bold;
  }
}

</style>
